// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import fastclick from 'fastclick'
import store from './store/Store'
import App from './App'
import router from './router'
import '../static/reset.css'
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import VCharts from 'v-charts'
import '../static/directives'
import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

Vue.use(ElementUI, VCharts)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  setTimeout((res) => {
    if (to.meta.requireAuth) {
      console.log(store.state.isLogin)
      if (store.state.isLogin === '100') {
        next()
      } else {
        next({
          path: '/Login',
          query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      next()
    }
  }, 100)
})

// 存：localStorage.setItem('mydata',JSON.stringify(data.body.data))
// 取：var mydata = JSON.parse(localStorage.mydata)
/* eslint-disable no-new */
Vue.component(VeLine.name, VeLine)
Vue.component(VePie.name, VePie)
Vue.component(VeHistogram.name, VeHistogram)
new Vue({
  el: '#app',
  router,
  store,
  fastclick,
  components: { App },
  template: '<App/>',
  created () {
    let isLogin = localStorage.isLogin
    console.log(typeof (isLogin))
    if (isLogin === '') {
      localStorage.setItem('isLogin', '')
    }
    this.$store.state.isLogin = localStorage.isLogin
    console.log(this.$store.state.isLogin)
  }
})



// WEBPACK FOOTER //
// ./src/main.js